export default "__VITE_ASSET__DRdk8TE___"